
/**
 * 
 * @param {*} dateStr (Date in string format, e.g. '2021-01-01' or 'dd/mm/yy')
 * @param {*} language 
 * @returns Returns a string with the trimester label (TN-YYYY)
 */
export function formatTrimesterLabel(dateStr, language = 'es') {
    //check if date is in dd/mm/yyyy format
    //console.log(dateStr);

    if(dateStr === undefined) return '';

    if (dateStr.includes('/')) {
        const date = dateStr.split('/');
        dateStr = `${date[2]}-${date[1]}-20${date[0]}`;
    }

    const date = new Date(dateStr);
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    let quarter;
    if (month <= 3) quarter = 1;
    else if (month <= 6) quarter = 2;
    else if (month <= 9) quarter = 3;
    else quarter = 4;
    return `${language === 'es' ? 'T' : 'Q'}${quarter}-${year}`;
}